<fieldset [disabled]="editable" class="container w-100 my-3">
	<div class="d-flex justify-content-between header-container">
		<h4>Pokoje</h4>
	</div>
	<div class="mb-3 my-5">
		<div class="col-sm-8 w-100">
			<ng-select
				[disabled]="editable"
				[(ngModel)]="passRoomType"
				placeholder="Wybierz typ pokoju"
				class="w-100"
				required
			>
				<ng-option [value]="item.id" *ngFor="let item of service.mockData.roomType">
					{{ item.code }} | {{ item.name }}
				</ng-option>
			</ng-select>
		</div>
	</div>
	<div class="mb-3">
		<div class="col-sm-8 w-100">
			<mat-form-field class="w-100">
				<input
					matInput
					type="number"
					placeholder="Wprowdź ilość pokoi"
					[(ngModel)]="roomCount"
					[disabled]="editable"
					required
					max="50"
				/>
				<mat-label>Ilość pokoi</mat-label></mat-form-field
			>
		</div>
	</div>
	<div class="mb-3">
		<div class="col-sm-8 w-100">
			<mat-form-field class="w-100">
				<input
					matInput
					type="number"
					[disabled]="editable"
					[ngModel]="passFee !== undefined ? (passFee | price) : null"
					(ngModelChange)="passFee = convertPriceToGrosze($event)"
					required
				/>
				<mat-label>Wprowadź dopłatę w PLN</mat-label>
			</mat-form-field>
		</div>
	</div>
	<div class="col-sm-6">
		<mat-slide-toggle id="isNoName" class="example-margin" color="primary" [(ngModel)]="passIsNoName">
			Czy jest noName?
		</mat-slide-toggle>
	</div>
	<hr />
	<div *ngFor="let subRoom of subRooms; let i = index">
		<div class="d-flex justify-content-between">
			<h4>Pokój podrzędny - {{ i + 1 }}<sup class="text-danger text-sm">* wymagane</sup></h4>
			<i class="fa-solid fa-trash-can" (click)="removeSubRoom(i)"></i>
		</div>
		<div class="row mb-3">
			<div class="col-sm-8">
				<ng-select [(ngModel)]="subRoom.roomType" placeholder="Wybierz typ pokoju z list" required>
					<ng-option>Wybierz typ pokoju z listy</ng-option>
					<ng-option [value]="item.id" *ngFor="let item of service.mockData.roomType">
						{{ item.code }} | {{ item.name }}
					</ng-option>
				</ng-select>
			</div>
			<div class="col-sm-4">
				<div class="input-group">
					<mat-form-field class="w-100"
						><input
							matInput
							type="number"
							placeholder="Wprowadź dopłatę"
							[ngModel]="subRoom.fee !== undefined ? (subRoom.fee | price) : null"
							(ngModelChange)="subRoom.fee = convertPriceToGrosze($event)"
							min="0"
						/>
						<mat-label>Wprowadź dopłatę w PLN</mat-label></mat-form-field
					>
				</div>
			</div>
		</div>
	</div>

	<hr />
	<div class="d-flex justify-content-between fixed">
		<button mat-raised-button color="accent" (click)="addSubRoom()" [disabled]="editable">
			<i class="fa-solid fa-plus"></i> Dodaj pokój podrzędny
		</button>

		<button
			mat-raised-button
			color="primary"
			(click)="addRooms()"
			[disabled]="editable"
			matTooltip="Pamiętaj! Po kliknięciu przycisku zatwierdź aby dodać pokoje do produktu musisz zapisać przyciskiem w górnym panelu na stronie!"
		>
			<i class="fa-solid fa-circle-check"></i> Zatwierdź
		</button>
	</div>
</fieldset>
